export const Monogram = ({ className = "h-16 w-16" }) => (
    <svg viewBox="0 0 96 96" fill="none" className={className} aria-hidden="true">
        <path
            d="M16 88 V40 C16 20 30 8 48 8 C66 8 80 20 80 40 V88"
            stroke="#E5B82A"
            strokeWidth="2.4"
        />
        <path
            d="M24 88 V42 C24 27 34 17 48 17 C62 17 72 27 72 42 V88"
            stroke="#E5B82A"
            strokeWidth="1"
            opacity="0.45"
        />
        <text
            x="48"
            y="62"
            textAnchor="middle"
            fontFamily="Cinzel, Georgia, serif"
            fontSize="26"
            letterSpacing="2"
            fill="#E5B82A"
        >
            S·T
        </text>
        <circle cx="48" cy="76" r="2.2" fill="#E5B82A" />
        <circle cx="48" cy="4.5" r="1.8" fill="#E5B82A" />
    </svg>
);

export const Divider = ({ className = "", label }) => (
    <div className={`flex items-center justify-center gap-4 ${className}`} aria-hidden="true">
        <span className="h-px w-16 sm:w-28 bg-gradient-to-r from-transparent to-gold/60" />
        <span className="rotate-45 border border-gold/70 p-[3px]">
            <span className="block h-1.5 w-1.5 bg-gold" />
        </span>
        {label ? (
            <span className="font-devanagari text-gold/80 text-sm sm:text-base px-2">{label}</span>
        ) : null}
        <span className="rotate-45 border border-gold/70 p-[3px]">
            <span className="block h-1.5 w-1.5 bg-gold" />
        </span>
        <span className="h-px w-16 sm:w-28 bg-gradient-to-l from-transparent to-gold/60" />
    </div>
);

export const CornerFlourish = ({ className = "" }) => (
    <svg viewBox="0 0 80 80" fill="none" className={className} aria-hidden="true">
        <path
            d="M4 76 V22 C4 12 12 4 22 4 H76"
            stroke="#E5B82A"
            strokeWidth="1.6"
            opacity="0.85"
        />
        <path
            d="M12 76 V28 C12 19 19 12 28 12 H76"
            stroke="#E5B82A"
            strokeWidth="0.8"
            opacity="0.4"
        />
        <circle cx="22" cy="22" r="2.4" fill="#E5B82A" opacity="0.9" />
        <path
            d="M22 22 C30 26 34 32 35 42 M22 22 C26 30 32 34 42 35"
            stroke="#E5B82A"
            strokeWidth="0.9"
            opacity="0.55"
        />
    </svg>
);

export default Monogram;
